module.exports = __webpack_public_path__ + "media/images/countdown-26766bafc846e63975a59aa2d04e850c.png";